import { TruckPlusOutlineIcon } from './TruckPlusOutlineIcon';

/**
 * author: Colton Wiscombe
 * id E920C53D-E340-42C1-86D6-9A1317D9A584
 * name truck-plus-outline
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/truck-plus-outline.svg
 * tags
 * - Transportation + Road 
 * - Medical / Hospital 
 */
export const TruckAddOutlineIcon = TruckPlusOutlineIcon;
export default TruckAddOutlineIcon